/* ============================================================
   FREE GIFT LOGIC
   Threshold: $175 gift
   Gift: performance-compression-crew-socks
   Progress bar: handled by theme — disabled here
   ============================================================ */

(function() {
  var FREE_GIFT_THRESHOLD = 17500;
  var GIFT_HANDLE = 'performance-compression-crew-socks';
  var GIFT_DISPLAY_PRICE = '$16.99';
  var isAddingGift = false;
  var giftProductData = null;
  var debounceTimer = null;
  var selectedVariantId = null;

  function fetchGiftProduct() {
    if (giftProductData) return Promise.resolve(giftProductData);
    return fetch('/products/' + GIFT_HANDLE + '.js')
      .then(function(r) { return r.json(); })
      .then(function(data) { giftProductData = data; return data; })
      .catch(function(e) { console.error('[FreeGift] fetch error', e); return null; });
  }

  function getQualifyingSubtotal(cart) {
    var total = 0;
    for (var i = 0; i < cart.items.length; i++) {
      if (cart.items[i].handle !== GIFT_HANDLE) {
        total += cart.items[i].final_line_price;
      }
    }
    return total;
  }

  function getGiftLineItem(cart) {
    for (var i = 0; i < cart.items.length; i++) {
      if (cart.items[i].handle === GIFT_HANDLE) return cart.items[i];
    }
    return null;
  }

  function removeGiftFromCart(giftItem) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: giftItem.key, quantity: 0 })
    });
  }

  function addGiftToCart(variantId) {
    if (isAddingGift) return;
    isAddingGift = true;
    selectedVariantId = variantId;

    var picker = document.querySelector('.dc-free-gift-picker');
    if (picker) {
      picker.querySelectorAll('.dc-gift-size-btn').forEach(function(b) {
        b.disabled = true;
        if (parseInt(b.dataset.variantId) === variantId) {
          b.style.background = '#111';
          b.style.color = '#fff';
          b.style.borderColor = '#111';
          b.style.opacity = '1';
        } else {
          b.style.opacity = '0.4';
          b.style.background = '#fff';
          b.style.color = '#222';
        }
      });
    }

    fetch('/cart.js')
      .then(function(r) { return r.json(); })
      .then(function(cart) {
        var existing = getGiftLineItem(cart);
        if (existing) {
          return fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: existing.key, quantity: 0 })
          }).then(function() {
            return fetch('/cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
            });
          });
        }
        return fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
        });
      })
      .then(function() {
        isAddingGift = false;
        var picker2 = document.querySelector('.dc-free-gift-picker');
        if (picker2) {
          picker2.querySelectorAll('.dc-gift-size-btn').forEach(function(b) {
            b.disabled = false;
            b.style.opacity = '1';
            if (parseInt(b.dataset.variantId) === variantId) {
              b.style.background = '#111';
              b.style.color = '#fff';
              b.style.borderColor = '#111';
            } else {
              b.style.background = '#fff';
              b.style.color = '#222';
              b.style.borderColor = '#222';
            }
          });
        }
        setTimeout(function() {
          fetch('/cart.js')
            .then(function(r) { return r.json(); })
            .then(function(cart) { updateGiftLineDisplay(); });
        }, 800);
      })
      .catch(function(e) {
        console.error('[FreeGift] add error', e);
        isAddingGift = false;
      });
  }

  function renderGiftPicker(show) {
    var container = document.querySelector('.dc-free-gift-picker');
    if (!container) return Promise.resolve();
    if (!show) {
      container.style.display = 'none';
      return Promise.resolve();
    }
    return fetchGiftProduct().then(function(product) {
      if (!product) return;
      var variants = product.variants;
      var image = product.featured_image || '';

      container.style.cssText = 'display:block !important;padding:16px;border-top:1px solid rgba(0,0,0,0.08);background:#fff;';

      var sizeButtons = variants.map(function(v) {
        var isSelected = selectedVariantId && parseInt(v.id) === selectedVariantId;
        var btnStyle = isSelected
          ? 'min-width:40px;padding:6px 12px;border:1px solid #111;border-radius:3px;background:#111;color:#fff;font-size:12px;font-weight:600;cursor:pointer;margin:0;'
          : 'min-width:40px;padding:6px 12px;border:1px solid #222;border-radius:3px;background:#fff;color:#222;font-size:12px;font-weight:600;cursor:pointer;margin:0;';
        return '<button class="dc-gift-size-btn" data-variant-id="' + v.id + '" type="button" style="' + btnStyle + '">' + v.title + '</button>';
      }).join('');

      container.innerHTML =
        '<div style="font-size:11px;font-weight:700;color:#e00000;text-transform:uppercase;letter-spacing:0.08em;margin-bottom:12px;">🎁 FREE GIFT UNLOCKED</div>' +
        '<div style="display:flex;flex-direction:row;gap:12px;align-items:flex-start;">' +
          (image ? '<img src="' + image + '" alt="' + product.title + '" style="width:80px;height:80px;object-fit:cover;border-radius:4px;flex-shrink:0;">' : '') +
          '<div style="display:flex;flex-direction:column;gap:4px;flex:1;min-width:0;">' +
            '<div style="font-size:13px;font-weight:600;color:#111;">' + product.title + '</div>' +
            '<div style="display:flex;align-items:center;gap:8px;">' +
              '<span style="font-size:13px;color:#999;text-decoration:line-through;">' + GIFT_DISPLAY_PRICE + '</span>' +
              '<span style="font-size:13px;font-weight:700;color:#e00000;">FREE</span>' +
            '</div>' +
            '<div style="font-size:12px;color:#444;margin-top:6px;">' + (selectedVariantId ? 'Change your size:' : 'Choose your size:') + '</div>' +
            '<div style="display:flex;flex-wrap:wrap;gap:6px;margin-top:4px;">' + sizeButtons + '</div>' +
          '</div>' +
        '</div>';

      container.querySelectorAll('.dc-gift-size-btn').forEach(function(btn) {
        btn.addEventListener('click', function() {
          addGiftToCart(parseInt(btn.dataset.variantId));
        });
      });
    });
  }

  function updateGiftLineDisplay() {
    document.querySelectorAll('.cart-item--product-' + GIFT_HANDLE).forEach(function(item) {
      if (!item.querySelector('.dc-gift-badge')) {
        var badge = document.createElement('span');
        badge.className = 'dc-gift-badge';
        badge.textContent = 'FREE GIFT';
        badge.style.cssText = 'display:inline-block;background:#e00000;color:#fff;font-size:9px;font-weight:700;letter-spacing:0.06em;padding:2px 5px;border-radius:2px;margin-left:6px;vertical-align:middle;text-transform:uppercase;';
        var titleEl = item.querySelector('.cart-item__name, .cart-item__title, a');
        if (titleEl) titleEl.after(badge);
      }
      item.querySelectorAll('quantity-input, .cart-item__quantity-wrapper').forEach(function(el) {
        el.style.display = 'none';
      });
      item.querySelectorAll('.cart-remove-button').forEach(function(el) {
        el.style.display = 'none';
      });
      var priceWrapper = item.querySelector('.cart-item__price-wrapper, .cart-item__price');
      if (priceWrapper && !priceWrapper.querySelector('.dc-gift-free')) {
        priceWrapper.innerHTML =
          '<span style="text-decoration:line-through;color:#999;font-size:13px;">' + GIFT_DISPLAY_PRICE + '</span> ' +
          '<span class="dc-gift-free" style="color:#e00000;font-weight:700;font-size:13px;">FREE</span>';
      }
    });
  }

  function injectElements() {
    var body = document.querySelector('.cart-drawer__body');
    if (!body) return;

    if (!document.querySelector('.dc-free-gift-picker')) {
      var picker = document.createElement('div');
      picker.className = 'dc-free-gift-picker';
      picker.style.display = 'none';
      var cartForm = document.querySelector('#CartDrawer-Form, form.cart_contents');
      if (cartForm) {
        if (cartForm.nextSibling) {
          cartForm.parentElement.insertBefore(picker, cartForm.nextSibling);
        } else {
          cartForm.parentElement.appendChild(picker);
        }
      }
    }
  }

  function evaluateCart() {
    fetch('/cart.js')
      .then(function(r) { return r.json(); })
      .then(function(cart) {
        var qualifyingSubtotal = getQualifyingSubtotal(cart);
        var giftItem = getGiftLineItem(cart);

        if (giftItem && qualifyingSubtotal < FREE_GIFT_THRESHOLD) {
          selectedVariantId = null;
          removeGiftFromCart(giftItem).then(function() {
            setTimeout(evaluateCart, 800);
          });
          return;
        }

        if (giftItem && giftItem.quantity > 1) {
          fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: giftItem.key, quantity: 1 })
          }).then(function() { setTimeout(evaluateCart, 800); });
          return;
        }

        if (giftItem && !selectedVariantId) {
          selectedVariantId = giftItem.variant_id;
        }

        injectElements();
        var shouldShow = qualifyingSubtotal >= FREE_GIFT_THRESHOLD && !isAddingGift;
        renderGiftPicker(shouldShow).then(function() {
          updateGiftLineDisplay();
        });
      })
      .catch(function(e) { console.error('[FreeGift] evaluateCart error', e); });
  }

  function debouncedEvaluate() {
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(evaluateCart, 700);
  }

  function init() {
    injectElements();
    evaluateCart();
    document.addEventListener('limespot:cartDrawerRender', debouncedEvaluate);
    var body = document.querySelector('.cart-drawer__body');
    if (body) {
      new MutationObserver(function() {
        injectElements();
        updateGiftLineDisplay();
      }).observe(body, { childList: true, subtree: false });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
